
import api from '@/api/api.js'

export default {
  state: {
    user: JSON.parse(localStorage.getItem('userObj'))
      ? JSON.parse(localStorage.getItem('userObj'))
      : ''
  },
  mutations: {
    setData(state, param) {//param:{key:*,val:*}
      var val = param.val;
      if (typeof param.val == "object") {
        val = JSON.stringify(val);
      }
      // console.log(param)
      eval(`state.${param.key}=${val}`);
    },
    logout() {
      localStorage.clear();
    }
  },
  actions: {
    getUserMess(context, userId) {
      return new Promise((resolve, reject) => {
        api.getUserByID({ volunteerId: userId }).then(res => {
          localStorage.setItem('hasLogin', true)

          let resp = { status: "", params: {} }

          if (res.data.volunteerInfo == null) {
            resp.status = null
          } else {
            let status = res.data.volunteerInfo.status
            let applyNumber = res.data.volunteerInfo.applyNumber
            let refuseType = res.data.volunteerInfo.refuseType
            let currentDate = res.data.volunteerInfo.currentDate
            let integralResult = res.data.integralResult
            let keepCount = res.data.keepCount
            let exitType = res.data.volunteerInfo.exitType
            let refuseReason = res.data.volunteerInfo.refuseReason

            localStorage.setItem('userObj', JSON.stringify(res.data.volunteerInfo))
            setTimeout(() => {
              context.commit('setData', { key: 'user', val: JSON.parse(localStorage.getItem('userObj')) })
              // console.log(context)
            }, 1000)

            // JSON.parse(localStorage.getItem('userObj'))
            if (status == 0) {
              resp.status = 0   //您的资料已提交到后台正在审核中！
            } else if (status == 1) {
              if (applyNumber == 3) {
                resp.status = 1   //您的申请志愿者资格机会已用光
              } else {
                if (refuseType == 1) {
                  resp.status = 2  //驳回原因：您的资料填写错误，请重新填写提交！
                  resp.params.reason = refuseReason
                  /********************************************************** */
                  resp.params.surplus = 3 - parseInt(applyNumber)  //	您还有2/0次资料提交机会！
                } else {
                  resp.status = 3  //驳回原因：试用期不合格
                  /********************************************************** */
                  resp.params.surplus = 3 - parseInt(applyNumber)  //	您还有2/0次资料提交机会！
                }
              }
            } else if (status == 2) {
              resp.status = 4  //首页
            } else if (status == 3) {
              let date = new Date(currentDate)
              let year = date.getFullYear();
              let start = Date.parse(date.getFullYear() + '-01-' + '01' + '' + '02:00:00')
              let end = Date.parse(date.getFullYear() + '-03-' + '31' + '' + '23:59:00')
              let end2 = Date.parse(date.getFullYear() + '-01-' + '15' + '' + '23:59:00')
              if (currentDate > start && currentDate < end) {
                if (integralResult == null || integralResult.integralResult == 1 || integralResult.integralResult == 2) {
                  resp.status = 4  //首页
                } else {
                  if (integralResult.keepQualification == 1) {
                    if (integralResult.status == 2) {

                      resp.status = 4  //首页
                    } else if (integralResult.status == 0) {
                      resp.status = 5  //保留资格正在审核中 ,您的申请保留资格审批中，请耐心等待！
                    }
                    // else if (integralResult.status == 1) {
                    //   resp.status = 6  //保您的申请保留资格被驳回，您已退出志愿者系统！ 驳回原因：不想给你通过
                    //   resp.params.reason = integralResult.refuseReason //表示驳回原因

                    // }
                  } else {
                    if (keepCount == 1) {
                      resp.status = 7 // 您本年度积分不合格，暂无保留资格申请？
                    } else {
                      if (currentDate < end2) {
                        resp.status = 8 // 您本年度积分不合格，是否申请保留资格？
                        if (integralResult.totalIntegral < 20) {
                          resp.params.reason = "由于本年度积分低于20，需向志愿者负责人递交本年度服务说明，等待审核通过"
                        }
                        else { resp.params.reason = "上年所欠时长需要在今年补齐" }
                      } else {
                        resp.status = 7 // 您本年度积分不合格，暂无保留资格申请？
                      }
                    }
                  }
                }
              } else {
                resp.status = 4  //首页
              }
            } else if (status == 4) {
              // resp.status = 10 // 您已退出志愿者系统！
              if (exitType == 1 || exitType == 2 || exitType == 3) {
                resp.status = 10 // 您已退出志愿者系统！

              } else {
                resp.status = 6  //保您的申请保留资格被驳回，您已退出志愿者系统！ 驳回原因：不想给你通过
                resp.params.reason = integralResult.refuseReason //表示驳回原因
              }
            }


            // commit(USER_LOGIN, {userInfo})
          }
          resolve(resp)
        }).catch(err => {
          // myConsole(err)
          reject(err)
        })
      })
      // api.getUserByID(userId).then(res => {
      //   console.log(res)
      //   let status
      //   if (res.data == null) {
      //     status = null
      //   }
      //   return status
      // })
    },
  }

}
